import { render, staticRenderFns } from "./productInventory.vue?vue&type=template&id=7c1d9110&"
import script from "./productInventory.vue?vue&type=script&lang=js&"
export * from "./productInventory.vue?vue&type=script&lang=js&"
import style0 from "./productInventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports